<template>
  <el-card class="tako-panel tako-color-normal">
    <template #header v-if="header">
      <el-row>
        <slot name="header">
          <el-col :span="12" class="panel-title">
            <slot name="title"></slot>
          </el-col>
          <el-col :span="12" class="panel-actions">
            <slot name="actions"></slot>
          </el-col>
        </slot>
      </el-row>
    </template>
    <slot></slot>
  </el-card>
</template>

<script setup>
import { defineProps } from "vue";

defineProps(["header"]);
</script>

<style></style>

<style lang="scss" scoped>
.tako-panel {
  border-radius: 5px;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.03);

  .panel-title {
    font-size: 18px;
    font-weight: bold;
  }

  .panel-actions {
    text-align: right;

    &:deep() {
      a {
        color: #409eff;
        font-size: 14px;
        position: relative;
        top: 4px;
      }
    }
  }

  &:deep() {
    .el-card__header {
      padding: 10px 20px;
    }

    .el-card__body {
      padding: 0px;
    }
  }
}
</style>
